import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import Footer from "../footer";
import ListRender from "./ListRender";
import PageTitle from "../theme/components/pagetitle";
import Loader from "../loader";
import {t} from "@lingui/core/macro";

export default class Actu extends Component{

    render(){
        const context=this.props.context
        const {org,config}=context
        const title=t`Actualités de ${org.name}`
        const description=t`Actualités de ${org.name}`

        if(this.props.loading){
            return (
                <div>
                    <Meta context={context} title={title} description={description}/>
                    <Loader/>
                </div>
            )
        }

        return(
            <div>
                <Meta context={context} title={title} description={description}/>
                <Header context={context}/>
                <PageTitle context={context} title={t`Actualités`} color="#05D16E"/>
                <div style={{minHeight:"50vh"}}>
                    <ListRender context={context}/>
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}
